<div class="multi-line-chart-wrapper">
  <div *ngIf="title" class="chart-title">{{ title }}</div>
  <div class="chart-area" *ngIf="chartData?.datasets?.length; else noData" [style.height]="chartHeight">
    <p-chart
      type="line"
      [data]="chartData"
      [options]="chartOptions"
      [plugins]="chartPlugins"
    ></p-chart>
  </div>

  <!-- Custom legend -->
  <div class="chart-legend" *ngIf="chartData">
    <span class="chart-legend-item" *ngFor="let item of legendItems">
      <span class="chart-legend-dot" [style.background]="item.color"></span>
      <span class="chart-legend-label">{{ item.label }}</span>
    </span>
  </div>

  <ng-template #noData>
    <div class="no-data-placeholder">
      <div class="no-data-title">Telemetry Data Empty</div>
      <div class="no-data-description">No LLM tokens were consumed by Assure, hence no telemetry data is available.</div>
    </div>
  </ng-template>
</div>
